<div class="main-container">
<form [formGroup]="loginForm" (ngSubmit)="onLogin()">
  <wa-card style="max-width: 45ch; margin: 0 auto">
  <div class="wa-stack">
    <h2 class="wa-heading-l">Guest Login</h2>
    <p>If you have a TUM account, please use the TUM login instead (accessible via the button on the top right of this page).</p>
    <wa-input id="email" label="Email" type="email" ngDefaultControl formControlName="email" autofocus required>
    @if (getErrorMessage(loginForm.controls['email'])) {
      <div slot="hint" class="error">{{ getErrorMessage(loginForm.controls['email']) }}</div>
    }
    </wa-input>
    <wa-input id="password" label="Password" type="password" ngDefaultControl formControlName="password" passwordToggle required>
    @if (getErrorMessage(loginForm.controls['password'])) {
      <div slot="hint" class="error">{{ getErrorMessage(loginForm.controls['password']) }}</div>
    }
    </wa-input>
    <wa-button type="submit" variant="neutral" appearance="filled" [disabled]="loginForm.invalid">
      <wa-icon slot="end" name="arrow-right-to-bracket"></wa-icon>
      Sign in
    </wa-button>
  </div>
</wa-card>
</form>
</div>
